module.exports = __webpack_public_path__ + "img/Sri-Lanka.c06dbc7b.png";